import {
  Component,
  Input,
  HostBinding,
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'suka-accordion',
  template: `
    <ng-content select="suka-accordion-item"></ng-content>
  `,
})
export class Accordion {
  protected _skeleton = false;

  openCloseItems = new Subject<boolean>();
  skeletons = new Subject<boolean>();

  /**
   * Set to `true` to allow multiple accordion items to be expanded.
   */
  @Input() multi = false;


  @HostBinding('attr.role') role = 'list';
  @HostBinding('class.accordion') baseClass = true;

  /**
   * Set to `true` to display a loading accordion.
   */
  @Input()
  set skeleton(value: any) {
    this._skeleton = value;
    this.updateSkeletons();
  }

  get skeleton(): any {
    return this._skeleton;
  }

  protected updateSkeletons() {
    this.skeletons.next(this._skeleton);
  }

}
